export default {
  GET_ALL_LOGISTICS_PARTNER_DETAIL: "GET_ALL_LOGISTICS_PARTNER_DETAIL",
  SAVE_LOGISTICS_PARTNER_DETAIL: "SAVE_LOGISTICS_PARTNER_DETAIL",
};
